import React from "react";
import { useDarkMode } from "../../contexts/DarkModeContext";
import { usePermissions } from "../../hooks/usePermissions";
import type { BillReleaseTab } from "../../utils/billReleaseScreenConfig";

interface BillReleaseTabsProps {
  activeTab: BillReleaseTab;
  onTabChange: (tab: BillReleaseTab) => void;
}

const BillReleaseTabs: React.FC<BillReleaseTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  const { isDarkMode } = useDarkMode();
  const { hasPermission } = usePermissions();

  const showCustomer = hasPermission("189", "View");
  const showVendor = hasPermission("194", "View");

  if (!showCustomer && !showVendor) {
    return null;
  }

  const tabButtonStyles = (isActive: boolean): React.CSSProperties => ({
    padding: "10px 0",
    backgroundColor: "transparent",
    border: "none",
    borderBottom: isActive ? "2px solid #34D399" : "2px solid transparent",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 600,
    letterSpacing: "0.04em",
    color: isActive
      ? isDarkMode
        ? "#f1f5f9"
        : "#0F172A"
      : isDarkMode
        ? "#94a3b8"
        : "#64748B",
    marginRight: "20px",
    transition: "all 0.2s ease",
  });

  return (
    <div style={{ marginBottom: 12 }}>
      <div
        style={{
          display: "flex",
          gap: "8px",
          borderBottom: isDarkMode ? "1px solid #334155" : "1px solid #E5E7EB",
          padding: "0 4px",
        }}
      >
        {showCustomer ? (
          <button
            type="button"
            style={tabButtonStyles(activeTab === "customer")}
            onClick={() => onTabChange("customer")}
            aria-selected={activeTab === "customer"}
          >
            CUSTOMER
          </button>
        ) : null}
        {showVendor ? (
          <button
            type="button"
            style={tabButtonStyles(activeTab === "vendor")}
            onClick={() => onTabChange("vendor")}
            aria-selected={activeTab === "vendor"}
          >
            VENDOR
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default BillReleaseTabs;
